import classNames from 'classnames/bind';
import React from 'react';

import styles from './BottomBar.module.scss';

import Geo from '@/components/ui/Geo';
import TimeClock from '@/components/ui/TimeClock';

const cx = classNames.bind(styles);

const BottomBar = () => {
  return (
    <div className={cx('container')}>
      <Geo />
      <TimeClock />
    </div>
  );
};

export default BottomBar;
